// Centralized query keys for React Query
export const blackdayKeys = {
  // Planner related queries
  planner: {
    getUpcomingBlackday: ['planner', 'upcoming-blackday'] as const,
    getAllActiveBlackdays: ['planner', 'all-active-blackdays'] as const,
  },
} as const;
